<div class="widget-header">
  <div class="widget-header__title">{{ title }}</div>

  <div class="widget-header__content">
    <ng-content></ng-content>
  </div>
</div>
